import { tryCatch } from "@/lib/try-catch";
import { Ok, Err } from "ts-results";
import { API_BASE_URL } from "@/lib/constants";
import { Response } from "./types";
import { z } from "zod";

export const extractLightingDataSchema = z.object({
  imageUrls: z
    .array(z.string(), {
      message: "No se puede extraer datos sin imagenes",
    })
    .min(1, {
      message: "Se debe subir al menos una imagen",
    }),
});

export type ExtractLightingDataRequest = z.infer<
  typeof extractLightingDataSchema
>;

export async function extractLightingData(
  request: ExtractLightingDataRequest,
): Promise<Response<Blob>> {
  const responseResult = await tryCatch(
    fetch(`${API_BASE_URL}/api/v1/extraer-datos/iluminacion`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    }),
  );

  if (responseResult.err) {
    return Err({
      message: `Error al consultar el servidor: ${responseResult.val.message}`,
      devMessage: responseResult.val.message,
    });
  }

  const response = responseResult.val;

  if (!response.ok) {
    const errMessageResult = await tryCatch(response.json());
    return errMessageResult.err
      ? Err({
          message: `Error al leer la respuesta del servidor: ${errMessageResult.val.message}`,
          devMessage: errMessageResult.val.message,
        })
      : Err(errMessageResult.val);
  }

  const dataResult = await tryCatch(response.blob());

  if (dataResult.err) {
    return Err({
      message: `Error al leer la respuesta del servidor: ${dataResult.val.message}`,
      devMessage: dataResult.val.message,
    });
  }

  return Ok(dataResult.val);
}
